// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Nq-z","breadcrumbForward":"Oq-z","breadcrumbBack":"Pq-z","selected":"Qq-z"};